import React, { Suspense } from "react";

import {
    GlobalFooterFallback,
    type GlobalFooterPatternProps
} from "./global-footer";

const Footer = React.lazy(() =>
    // @ts-expect-error
    import("./global-footer").then(({ GlobalFooterSync }) => ({
        default: GlobalFooterSync
    }))
);

export const GlobalFooter = (props: GlobalFooterPatternProps) => (
    <Suspense fallback={<GlobalFooterFallback />}>
        <Footer {...props} />
    </Suspense>
);
